import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { get } from 'lodash-es';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: [ './alert-dialog.component.scss' ],
})
export class AlertDialogComponent {

  get title(): string {
    return get(this.dialogData, 'title', 'APP.GENERAL.DIALOG.CANCEL_WARNING');
  }

  get confirmation(): boolean {
    return get(this.dialogData, 'confirmation', true);
  }

  get customIcon(): string {
    return get(this.dialogData, 'customIcon', null);
  }

  get centerText(): string {
    return get(this.dialogData, 'centerText', true);
  }

  get closeButton(): string {
    return get(this.dialogData, 'closeButton', 'APP.GENERAL.CANCEL');
  }

  get successButton(): string {
    return get(this.dialogData, 'successButton', 'APP.GENERAL.LEAVE');
  }

  get okButton(): string {
    return get(this.dialogData, 'okButton', 'APP.GENERAL.OK');
  }
  constructor(
    private dialogRef: MatDialogRef<AlertDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public dialogData
  ) {}
  onClose(): void {
    this.dialogRef.close(true);
  }
}
